import React from "react";
import styles from "./HoldTransaction.module.scss";

const holdItems = [
  {
    invoice_id: "6331109544359911336",
    date: "2022-06-17",
    sales: 480,
  },
  {
    invoice_id: "5557010398168869",
    date: "2022-06-17",
    sales: 168,
  },
  {
    invoice_id: "67623893339484234",
    date: "2022-06-17",
    sales: 328,
  },
];

interface IProps {
  closeModel: any;
}
const HoldTransaction: React.FC<IProps> = ({ closeModel }) => {
  return (
    <div className={styles.overlay_model}>
      <div className={styles.hold_model}>
        <div className={styles.hold_header}>
          <span>Hold Transaction</span>
        </div>
        <div className={styles.hold_body}>
          {holdItems.map((item: any, index: number) => (
            <div className={styles.hold_item}>
              <span>{item.invoice_id}</span>
              <span>{item.date}</span>
              <span>Rs. {item.sales}</span>
              <button>Recall</button>
            </div>
          ))}
        </div>
        <div className={styles.hold_footer}>
          <button onClick={closeModel}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default HoldTransaction;
